(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.bf-bb').forEach(function (root) {
      /* gallery */
      var strip = root.querySelector('.bf-bb__thumbs');
      var main = strip ? document.getElementById(strip.dataset.main) : null;
      if (strip && main) {
        var thumbs = Array.prototype.slice.call(strip.querySelectorAll('.bf-bb__thumb'));
        function activate(i) {
          if (i < 0) i = thumbs.length - 1; if (i >= thumbs.length) i = 0;
          var b = thumbs[i]; if (!b) return;
          main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = b.dataset.src;
          thumbs.forEach(function (t) { t.classList.remove('is-active'); }); b.classList.add('is-active');
          b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
        strip.addEventListener('click', function (e) { var b = e.target.closest('.bf-bb__thumb'); if (b) activate(thumbs.indexOf(b)); });
        root.querySelectorAll('.bf-bb__gbtn').forEach(function (a) {
          a.addEventListener('click', function () { var c = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); }); activate(a.dataset.dir === 'next' ? c + 1 : c - 1); });
        });
        var stage = root.querySelector('.bf-bb__card') || main, sx = 0, sy = 0, tr = false;
        function ci() { return thumbs.findIndex(function (t) { return t.classList.contains('is-active'); }); }
        stage.addEventListener('touchstart', function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; tr = true; }, { passive: true });
        stage.addEventListener('touchend', function (e) { if (!tr) return; tr = false; var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) activate(dx < 0 ? ci() + 1 : ci() - 1); }, { passive: true });
        stage.style.touchAction = 'pan-y';
      }

      /* dosage toggle (visual) */
      root.querySelectorAll('.bf-bb__dose').forEach(function (btn) {
        btn.addEventListener('click', function () {
          root.querySelectorAll('.bf-bb__dose').forEach(function (d) { d.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });

      /* bundle selector + ATC price */
      var qtyInput = root.querySelector('[data-qty-input]');
      var planInput = root.querySelector('[data-plan-input]');
      var offerInput = root.querySelector('[data-offer-input]');
      var giftsInput = root.querySelector('[data-gifts-input]');
      var regularInput = root.querySelector('[data-regular-input]');
      var atcPrice = root.querySelector('[data-atc-price]');
      var atcCompare = root.querySelector('[data-atc-compare]');
      var atcSave = root.querySelector('[data-atc-save]');

      function currentOffer() { return root.querySelector('.bf-offer__input:checked'); }
      function update() {
        var r = currentOffer();
        /* both options are a single unit of the real variant, so quantity is always 1 */
        if (qtyInput) qtyInput.value = '1';
        if (atcPrice) atcPrice.textContent = r ? (r.dataset.price || '') : '';
        if (atcSave) atcSave.textContent = (r && r.dataset.save) ? '\u00b7 ' + r.dataset.save : '';
        if (atcCompare) atcCompare.textContent = '';
        /* the selling plan rides on the subscription option only -- never on one-time */
        if (planInput) {
          var plan = (r && r.value === 'sub' && r.dataset.plan) ? r.dataset.plan : '';
          if (plan) { planInput.value = plan; planInput.disabled = false; }
          else { planInput.value = ''; planInput.disabled = true; }
        }
        if (offerInput) {
          if (r && r.dataset.offer) { offerInput.value = r.dataset.offer; offerInput.disabled = false; }
          else { offerInput.value = ''; offerInput.disabled = true; }
        }
        if (giftsInput) {
          if (r) { giftsInput.value = r.dataset.gifts || '0'; giftsInput.disabled = false; }
          else { giftsInput.value = ''; giftsInput.disabled = true; }
        }
        /* On a subscription, hand the cart drawer the one-time price as the
           comparison basis so its summary reads One-time price / Subscription
           savings / Total savings against the real offer. Without it the drawer
           falls back to the variant's compare-at price, which is a different
           number entirely. One-time orders send nothing -- there is nothing to
           compare against. */
        if (regularInput) {
          var oneEl = root.querySelector('.bf-offer__input[value="one"]');
          var oneNum = oneEl ? parseFloat(String(oneEl.dataset.price || '').replace(/[^0-9.]/g, '')) : NaN;
          if (r && r.value === 'sub' && !isNaN(oneNum) && oneNum > 0) {
            regularInput.value = oneNum.toFixed(2); regularInput.disabled = false;
          } else { regularInput.value = ''; regularInput.disabled = true; }
        }
        root.querySelectorAll('.bf-offer__card').forEach(function (c) { c.classList.remove('is-selected'); });
        var card = r ? r.closest('.bf-offer__card') : null;
        if (card) card.classList.add('is-selected');
      }
      root.querySelectorAll('.bf-offer__input').forEach(function (radio) {
        radio.addEventListener('change', update);
      });
      /* the card is a div, so make the whole card selectable, not just the band label */
      root.querySelectorAll('[data-card]').forEach(function (card) {
        card.addEventListener('click', function (e) {
          if (e.target.closest('a, button')) return;
          var input = card.querySelector('.bf-offer__input');
          if (input && !input.checked) { input.checked = true; update(); }
        });
      });
      update();

      /* evergreen countdown */
      var cd = root.querySelector('[data-countdown]');
      if (cd) {
        var mins = parseInt(cd.dataset.minutes, 10) || 480;
        var key = 'auv_cd_' + mins;
        var ch = cd.querySelector('[data-h]'), cm = cd.querySelector('[data-m]'), cs = cd.querySelector('[data-s]');
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        var tickCd = function () {
          var dl = parseInt(localStorage.getItem(key) || '0', 10);
          if (!dl || dl < Date.now()) { dl = Date.now() + mins * 60000; localStorage.setItem(key, String(dl)); }
          var t = Math.floor(Math.max(0, dl - Date.now()) / 1000);
          if (ch) ch.textContent = pad(Math.floor(t / 3600));
          if (cm) cm.textContent = pad(Math.floor((t % 3600) / 60));
          if (cs) cs.textContent = pad(t % 60);
        };
        tickCd(); setInterval(tickCd, 1000);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-education"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.bf-ed').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.bf-ed__tab'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('.bf-ed__panel'));
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var i = tab.dataset.tab;
          tabs.forEach(function (t) { var on = t.dataset.tab === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.panel === i); });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.bf-rv').forEach(function (root) {
      var track = root.querySelector('[data-track]');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('.bf-rv__card'));
      var dotsWrap = root.querySelector('[data-dots]');
      if (dotsWrap) {
        cards.forEach(function (_, i) {
          var d = document.createElement('button');
          d.type = 'button'; d.className = 'bf-rv__dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Go to review ' + (i + 1));
          dotsWrap.appendChild(d);
        });
      }
      var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('.bf-rv__dot')) : [];
      function cardW() { var c = cards[0]; if (!c) return track.clientWidth; var s = getComputedStyle(track); var gap = parseFloat(s.columnGap || s.gap || 16) || 16; return c.offsetWidth + gap; }
      function idx() { return Math.round(track.scrollLeft / cardW()); }
      function setActive(i) { dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); }); }
      track.addEventListener('scroll', function () { setActive(Math.max(0, Math.min(cards.length - 1, idx()))); }, { passive: true });
      root.querySelectorAll('.bf-rv__arrow').forEach(function (a) {
        a.addEventListener('click', function () {
          var i = idx() + (a.dataset.dir === 'next' ? 1 : -1);
          i = Math.max(0, Math.min(cards.length - 1, i));
          track.scrollTo({ left: i * cardW(), behavior: 'smooth' });
        });
      });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { track.scrollTo({ left: i * cardW(), behavior: 'smooth' }); }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.bf-st').forEach(function (root) {
      var track = root.querySelector('[data-track]'); if (!track) return;
      var pages = Array.prototype.slice.call(track.querySelectorAll('.bf-st__page'));
      var dotsWrap = root.querySelector('[data-dots]');
      if (pages.length < 2) { var nav = root.querySelector('[data-nav]'); if (nav) nav.style.display = 'none'; return; }
      if (dotsWrap) { pages.forEach(function (_, i) { var d = document.createElement('button'); d.type='button'; d.className='bf-st__dot'+(i===0?' is-active':''); d.setAttribute('aria-label','Slide '+(i+1)); dotsWrap.appendChild(d); }); }
      var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('.bf-st__dot')) : [];
      function pageW(){ return pages[0] ? pages[0].offsetWidth : track.clientWidth; }
      function idx(){ return Math.round(track.scrollLeft / pageW()); }
      track.addEventListener('scroll', function(){ var i=Math.max(0,Math.min(pages.length-1,idx())); dots.forEach(function(d,j){ d.classList.toggle('is-active', j===i); }); }, {passive:true});
      dots.forEach(function(d,i){ d.addEventListener('click', function(){ track.scrollTo({left:i*pageW(),behavior:'smooth'}); }); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.bf-tl').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.bf-tl__tab'));
      function groups(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
      var sets = [groups('[data-tl-dot]'), groups('[data-tl-bubble]'), groups('[data-tl-xlabel]'), groups('[data-tl-panel]')];
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var i = tab.getAttribute('data-tl-tab');
          tabs.forEach(function (t) { var on = t.getAttribute('data-tl-tab') === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
          sets.forEach(function (list) {
            list.forEach(function (el) {
              var key = el.getAttribute('data-tl-dot') || el.getAttribute('data-tl-bubble') || el.getAttribute('data-tl-xlabel') || el.getAttribute('data-tl-panel');
              el.classList.toggle('is-active', key === i);
            });
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mars-announcement"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('.mars-ann');
    if (!bar) return;
    if (bar.dataset.link) {
      bar.addEventListener('click', function () { window.location.href = bar.dataset.link; });
    }
    var msgs = Array.prototype.slice.call(bar.querySelectorAll('.mars-ann__msg'));
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (msgs.length < 2 || reduce) return;
    var i = 0, timer = null;
    var next = function () { msgs[i].hidden = true; i = (i + 1) % msgs.length; msgs[i].hidden = false; };
    var start = function () { timer = setInterval(next, 5000); };
    var stop = function () { clearInterval(timer); };
    start();
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mars-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.mars-bb__gallery-nav').forEach(function (nav) {
      var strip = nav.querySelector('.mars-bb__thumbs');
      if (!strip) return;
      var main = document.getElementById(strip.dataset.main);
      var thumbs = Array.prototype.slice.call(strip.querySelectorAll('.mars-bb__thumb'));
      function activate(i) {
        if (i < 0) i = thumbs.length - 1;
        if (i >= thumbs.length) i = 0;
        var btn = thumbs[i];
        if (!btn || !main) return;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = btn.dataset.src;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        btn.classList.add('is-active');
        btn.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      strip.addEventListener('click', function (e) {
        var btn = e.target.closest('.mars-bb__thumb');
        if (btn) activate(thumbs.indexOf(btn));
      });
      nav.querySelectorAll('.mars-bb__arrow').forEach(function (arrow) {
        arrow.addEventListener('click', function () {
          var cur = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
          activate(arrow.dataset.dir === 'next' ? cur + 1 : cur - 1);
        });
      });

      // swipe the main image to change photo (mobile + trackpad/mouse drag)
      if (main) {
        var swipeEl = main.closest('.mars-bb__card') || main;
        var sx = 0, sy = 0, tracking = false;
        function curIndex() { return thumbs.findIndex(function (t) { return t.classList.contains('is-active'); }); }
        function onStart(x, y) { sx = x; sy = y; tracking = true; }
        function onEnd(x, y) {
          if (!tracking) return;
          tracking = false;
          var dx = x - sx, dy = y - sy;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            activate(dx < 0 ? curIndex() + 1 : curIndex() - 1);
          }
        }
        swipeEl.addEventListener('touchstart', function (e) { var t = e.touches[0]; onStart(t.clientX, t.clientY); }, { passive: true });
        swipeEl.addEventListener('touchend', function (e) { var t = e.changedTouches[0]; onEnd(t.clientX, t.clientY); }, { passive: true });
        swipeEl.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') onStart(e.clientX, e.clientY); });
        swipeEl.addEventListener('pointerup', function (e) { if (e.pointerType === 'mouse') onEnd(e.clientX, e.clientY); });
        swipeEl.style.touchAction = 'pan-y';
      }
    });
  })();

  (function () {
    document.querySelectorAll('[data-rev-slider]').forEach(function (sl) {
      var track = sl.querySelector('.mars-bb__rev-track');
      if (!track) return;
      var down = false, startX = 0, startScroll = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft;
        try { track.setPointerCapture(e.pointerId); } catch (err) {}
        track.style.cursor = 'grabbing';
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = startScroll - dx;
      });
      function settle() {
        if (!down) return;
        down = false; track.style.cursor = 'grab';
        var w = track.clientWidth;
        track.scrollTo({ left: Math.round(track.scrollLeft / w) * w, behavior: 'smooth' });
      }
      track.addEventListener('pointerup', settle);
      track.addEventListener('pointercancel', settle);
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mars-header"] && !Shopify.designMode) return;
  try {
    
  class MarsHeader extends HTMLElement {
    connectedCallback() {
      var self = this;
      var group = document.getElementById('header-group') || (this.closest('.shopify-section') || {}).parentElement;
      if (group && getComputedStyle(group).position !== 'sticky') {
        var bar = document.querySelector('.mars-ann');
        var off = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
        group.style.position = 'sticky'; group.style.top = (-off) + 'px'; group.style.zIndex = '50';
      }

      var onScroll = function () { self.classList.toggle('is-scrolled', window.scrollY > 8); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      var burger = this.querySelector('.mars-hd__burger');
      var drawer = this.querySelector('.mars-hd__drawer');
      var scrim = this.querySelector('[data-hd-scrim]');
      var close = this.querySelector('.mars-hd__drawer-close');
      if (!burger || !drawer) return;
      var setOpen = function (open) {
        if (open) { drawer.removeAttribute('hidden'); if (scrim) scrim.removeAttribute('hidden'); }
        else { drawer.setAttribute('hidden', ''); if (scrim) scrim.setAttribute('hidden', ''); }
        burger.setAttribute('aria-expanded', String(open));
        document.documentElement.style.overflow = open ? 'hidden' : '';
      };
      burger.addEventListener('click', function () { setOpen(drawer.hasAttribute('hidden')); });
      if (scrim) scrim.addEventListener('click', function () { setOpen(false); });
      if (close) close.addEventListener('click', function () { setOpen(false); });
      drawer.addEventListener('click', function (e) { if (e.target.closest('a')) setOpen(false); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hasAttribute('hidden')) setOpen(false); });
    }
  }
  if (!customElements.get('mars-header')) customElements.define('mars-header', MarsHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mars-ingredients"] && !Shopify.designMode) return;
  try {
    
  class MarsIngredients extends HTMLElement {
    connectedCallback() {
      var track = this.querySelector('[data-track]');
      if (!track) return;
      var prev = this.querySelector('[data-dir="prev"]');
      var next = this.querySelector('[data-dir="next"]');
      function step() {
        var card = track.querySelector('.mars-ing__card');
        if (!card) return track.clientWidth;
        var styles = getComputedStyle(track);
        var gap = parseInt(styles.columnGap || styles.gap || '16', 10) || 16;
        return card.getBoundingClientRect().width + gap;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      // drag-to-scroll (desktop pointer)
      var down = false, startX = 0, startScroll = 0, moved = false;
      track.addEventListener('pointerdown', function (e) { down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft; });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        track.scrollLeft = startScroll - dx;
      });
      function end() { down = false; }
      track.addEventListener('pointerup', end);
      track.addEventListener('pointerleave', end);
      track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); } }, true);
    }
  }
  if (!customElements.get('mars-ingredients')) customElements.define('mars-ingredients', MarsIngredients);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mars-listicle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-tbtimer]').forEach(function (el) {
      var mins = parseInt(el.dataset.min, 10) || 180;
      var key = 'mlctb_deadline';
      var dl = parseInt(localStorage.getItem(key) || '0', 10);
      if (!dl || dl < Date.now()) { dl = Date.now() + mins * 60000; localStorage.setItem(key, String(dl)); }
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var t = Math.floor(Math.max(0, dl - Date.now()) / 1000);
        if (h) h.textContent = pad(Math.floor(t / 3600));
        if (m) m.textContent = pad(Math.floor((t % 3600) / 60));
        if (s) s.textContent = pad(t % 60);
        if (t <= 0) { dl = Date.now() + mins * 60000; localStorage.setItem(key, String(dl)); }
      }
      tick(); setInterval(tick, 1000);
    });
  })();

  (function () {
    var bar = document.querySelector('[data-scta]');
    if (!bar) return;
    var trig = parseInt(bar.dataset.trigger, 10) || 3;
    var target = document.querySelector('.mlc__reason--i' + trig) || document.querySelector('.mlc__reason--i' + (trig - 1));
    if (!target) return;
    function reveal() { bar.classList.add('is-visible'); bar.setAttribute('aria-hidden', 'false'); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting || e.boundingClientRect.top < 0) { reveal(); io.disconnect(); }
        });
      }, { rootMargin: '0px 0px -25% 0px', threshold: 0 });
      io.observe(target);
    } else {
      window.addEventListener('scroll', function () {
        if (target.getBoundingClientRect().top < window.innerHeight * 0.75) reveal();
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mars-offer-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Shares the SAME deadline as the announcement bar (key 'mlctb_deadline'),
    // re-reading each tick so this countdown always matches the top bar exactly.
    document.querySelectorAll('.moc [data-timer]').forEach(function (el) {
      var mins = parseInt(el.dataset.minutes, 10) || 180;
      var key = 'mlctb_deadline';
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var dl = parseInt(localStorage.getItem(key) || '0', 10);
        if (!dl || dl < Date.now()) { dl = Date.now() + mins * 60000; localStorage.setItem(key, String(dl)); }
        var t = Math.floor(Math.max(0, dl - Date.now()) / 1000);
        if (h) h.textContent = pad(Math.floor(t / 3600));
        if (m) m.textContent = pad(Math.floor((t % 3600) / 60));
        if (s) s.textContent = pad(t % 60);
      }
      tick(); setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
